import Icon from '../components/Icon.vue'

Icon.register({
  signature: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M623.2 192c9.1-0.6 16.8 7.1 16.6 16.2v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8-6.1 6.2-14.3 9.4-22.6 9.4-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9c-7.5 4.8-17.4 2.6-22.1-4.9l-17.2-27c-4.7-7.5-2.5-17.4 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5z'
      }
    ]
  }
})
